var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConvert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.42.232C4.23.057 5.194 0 6.31 0h1.617c1.003 0 1.94.487 2.496 1.299l.813 1.185c.185.27.497.433.832.433h5.054c1.598 0 2.892 1.226 2.877 2.805-.013 1.29-.01 2.582-.006 3.873l.003 1.768c0 1.086-.058 2.024-.239 2.812-.182.8-.503 1.502-1.07 2.053-.566.55-1.288.862-2.11 1.04-.81.175-1.776.232-2.892.232H6.31c-1.116 0-2.081-.057-2.892-.232-.822-.178-1.544-.49-2.11-1.04-.567-.55-.888-1.253-1.07-2.053C.059 13.387 0 12.45 0 11.363V6.137C0 5.05.059 4.113.239 3.325c.182-.8.503-1.502 1.07-2.053.566-.55 1.288-.862 2.11-1.04ZM10 6a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2H7a1 1 0 1 1 0-2h2V7a1 1 0 0 1 1-1Z",
    fill: "#102026"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvert);
export default __webpack_public_path__ + "static/media/convert.f9cc126414d9b1e1cb948f7afcb03f71.svg";
export { ForwardRef as ReactComponent };